import { memo } from 'react';

import ListContainer from './ListContainer';
import PrioritizedListItem from './PrioritizedListItem';
import type { SortingByT } from './PrioritizedVehicleList';
import type { PrioritezedItem } from './types';
import { sortByMRMState } from './utils';

import { Severity } from 'API';

interface Props {
    items?: PrioritezedItem[];
    sortingBy?: SortingByT;
}

const PrioritizedItemsGroup = ({ items, sortingBy }: Props) => {
    const sortByTime = (items?: PrioritezedItem[]) => {
        if (!items) {
            return [];
        }

        if (sortingBy === 'byNewest') {
            return items.sort(
                (crr, nxt) => new Date(nxt.relativeTime).getTime() - new Date(crr.relativeTime).getTime()
            );
        }

        return items.sort((crr, nxt) => new Date(crr.relativeTime).getTime() - new Date(nxt.relativeTime).getTime());
    };

    if (!items) {
        return;
    }

    return (
        <>
            <ListContainer>
                {sortByTime(sortByMRMState(items, Severity.FATAL)).map(vehicle => (
                    <PrioritizedListItem key={vehicle.vin} vehicle={vehicle} />
                ))}
            </ListContainer>
            <ListContainer>
                {sortByTime(sortByMRMState(items, Severity.ERROR)).map(vehicle => (
                    <PrioritizedListItem key={vehicle.vin} vehicle={vehicle} />
                ))}
            </ListContainer>
            <ListContainer>
                {sortByTime(sortByMRMState(items, Severity.WARNING)).map(vehicle => (
                    <PrioritizedListItem key={vehicle.vin} vehicle={vehicle} />
                ))}
            </ListContainer>
            <ListContainer>
                {sortByTime(sortByMRMState(items, Severity.UNKNOWN)).map(vehicle => (
                    <PrioritizedListItem key={vehicle.vin} vehicle={vehicle} />
                ))}
            </ListContainer>
        </>
    );
};

export default memo(PrioritizedItemsGroup);
